import classnames from 'classnames'
import ThemeConsumer from 'embed/components/ThemeConsumer'
import { css } from 'emotion'
import * as React from 'react'

const styles = require('embed/styles/application')

export const ValidationError = ({ shouldShowIsInvalid, validationMessage }) => {
  if (!shouldShowIsInvalid || validationMessage === undefined) {
    return null
  }
  return (
    <ThemeConsumer>
      {({ errorStyles, fontFamilyPrimary }) => (
        <span
          dangerouslySetInnerHTML={{ __html: validationMessage }}
          className={classnames(
            styles.validationError,
            css`
              color: ${errorStyles?.color};
              font-family: ${fontFamilyPrimary};
            `,
          )}
        />
      )}
    </ThemeConsumer>
  )
}
